module.exports = __webpack_public_path__ + "img/global.ece7dc4c.svg";